<template>
  <div>
    <div class="login" v-if="notExist">
      <label class="login">该序列号不存在！</label><br><br>
      <a-button type='primary' @click="back">确定</a-button>
    </div>
    
    <div class="login" v-if="Exist">
      <a-input addon-before="序列号："  default-value="" v-model="SN"/>
    </div>
    <div class="login" v-if="Exist">
      <a-input addon-before="描述："  default-value="" v-model="description"/>
    </div>
    <div class="login" v-if="Exist">
      <a-input addon-before="位置："  default-value="" v-model="location"/>
    </div>
    <div class="login" v-if="Exist">
      <a-button type='primary' @click="submit">确定</a-button>
    </div>
  </div>
  
</template>
<script>
export default {
  data(){
    
    return {
      SN:"",
      description:"",
      location:"",
      notExist:false,
      Exist:false
    }
  },
  created()
  {
    let sn = this.$store.state.basestation;
    
    if(sn.length > 0){
      let param = {
        SN:sn
      }
      let obj = this.$qs.stringify(param)
      this.$axios({
        method:'post',
        url:'/api/basestation/query',
        data: obj
      }).then((response) =>{    
            //这里使用了ES6的语法
        if(response.data.length>0){
          this.Exist = true
          this.notExist = false
          let result = response.data[0]
          this.SN = result["sn"];
          this.description = result["description"];
          this.location = result["location"];
          console.log(response)       //请求成功返回的数据
        }
        else{
          this.Exist = false
          this.notExist = true
          console.log("not exist!")
        }
      }).catch((error) =>{
      
        console.log(error)       //请求失败返回的数据       
      })
    }
    else{
      this.Exist = true
      this.notExist = false
    }
  },
    methods:{
        back(){
          this.$router.push('/home/basestationlist')
        },
        submit (){
            let param = {
              sn:this.SN,
              description:this.description,
              location:this.location
            }
            let obj = this.$qs.stringify(param)
            if(this.SN=="")
            {
              alert("请完善信息！")
            }
            else
            {
              let sn = this.$store.state.basestation;
              if(sn.length>0){

                this.$axios({
                method:'post',
                url:'/api/basestation/update',
                data: obj
            }).then((response) =>{          //这里使用了ES6的语法
              let result = response.data
              if(result["result"])
              {
                this.$store.state.terminalid=""
                this.$router.push('/home/basestationlist')
              }

                console.log(response)       //请求成功返回的数据
            }).catch((error) =>{
                console.log(error)       //请求失败返回的数据
                
            })
              }
              else
              {
                this.$axios({
                method:'post',
                url:'/api/basestation/regist',
                data: obj
            }).then((response) =>{          //这里使用了ES6的语法
              let result = response.data
              if(result["result"])
              {
                this.$store.state.terminalid=""
                this.$router.push('/home/basestationlist')
              }

                console.log(response)       //请求成功返回的数据
            }).catch((error) =>{
                console.log(error)       //请求失败返回的数据
                
      })}
              
            }

        }
    }
}
</script>>
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.login {
  margin-top:20px;
  margin-left:auto;
  margin-right:auto;
  width:300px

}
</style>


// WEBPACK FOOTER //
// src/components/NewBasestation.vue